var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "facebook",
    width: 26,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgEAQAAACJ4248AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQflBwUMHDW2fWypAAAA/klEQVRYw+2VsQ6CMBCGDxUIG7OvYSIrceZReB5gcvINfABjGI2jLEQCLAwdTEhcHPo7GrWmWCEM9t967fW+u16uRD8K3POA9RrIc+B6BQDgcgFnDMgyYLH4NcaHwKYJxDGk8v1hABBF8uADAYAvl92CywEmSgRGGPaVzEzNbbUS2w8HwmZD1DQP2+nUFywREYHbtrjUdQ1uWd/ep/AEriu2p6kxud2GBzCmU/FG236fjGoT9igNIBX4btd96Lxqux25AmU5LgCq6s8r0AFA/hcY+z2BscfacYiC4O0cioLoeHz2PZ97zwmYz8UdnyQq940+BzSABtAAGkADaIA7vR0yF4UIr/0AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDctMDVUMTI6Mjg6NTMrMDA6MDDkM+2eAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTA3LTA1VDEyOjI4OjUzKzAwOjAwlW5VIgAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5aaeb5deb0e26c87521e8b81c71920ee.svg";
export { ForwardRef as ReactComponent };